export const CITIES_FR = [
  // =====================
  // GRANDES MÉTROPOLES
  // =====================
  { name: "Paris", lat: 48.8566, lng: 2.3522 },
  { name: "Lyon", lat: 45.7640, lng: 4.8357 },
  { name: "Marseille", lat: 43.2965, lng: 5.3698 },
  { name: "Toulouse", lat: 43.6047, lng: 1.4442 },
  { name: "Nice", lat: 43.7102, lng: 7.2620 },
  { name: "Nantes", lat: 47.2184, lng: -1.5536 },
  { name: "Montpellier", lat: 43.6119, lng: 3.8772 },
  { name: "Strasbourg", lat: 48.5734, lng: 7.7521 },
  { name: "Bordeaux", lat: 44.8378, lng: -0.5792 },
  { name: "Lille", lat: 50.6292, lng: 3.0573 },
  { name: "Rennes", lat: 48.1173, lng: -1.6778 },
  { name: "Reims", lat: 49.2583, lng: 4.0317 },
  { name: "Le Havre", lat: 49.4944, lng: 0.1079 },
  { name: "Saint-Étienne", lat: 45.4397, lng: 4.3872 },
  { name: "Toulon", lat: 43.1242, lng: 5.9280 },

  // =====================
  // VILLES MOYENNES
  // =====================
  { name: "Grenoble", lat: 45.1885, lng: 5.7245 },
  { name: "Annecy", lat: 45.8992, lng: 6.1294 },
  { name: "Chambéry", lat: 45.5646, lng: 5.9178 },
  { name: "Clermont-Ferrand", lat: 45.7772, lng: 3.0870 },
  { name: "Besançon", lat: 47.2378, lng: 6.0241 },
  { name: "Dijon", lat: 47.3220, lng: 5.0415 },
  { name: "Orléans", lat: 47.9029, lng: 1.9093 },
  { name: "Tours", lat: 47.3941, lng: 0.6848 },
  { name: "Poitiers", lat: 46.5802, lng: 0.3404 },
  { name: "Angers", lat: 47.4784, lng: -0.5632 },
  { name: "La Rochelle", lat: 46.1603, lng: -1.1511 },
  { name: "Niort", lat: 46.3237, lng: -0.4588 },
  { name: "Bourges", lat: 47.0810, lng: 2.3988 },
  { name: "Limoges", lat: 45.8336, lng: 1.2611 },
  { name: "Pau", lat: 43.2951, lng: -0.3708 },
  { name: "Bayonne", lat: 43.4929, lng: -1.4748 },
  { name: "Tarbes", lat: 43.2329, lng: 0.0781 },

  // =====================
  // SUD / MÉDITERRANÉE
  // =====================
  { name: "Avignon", lat: 43.9493, lng: 4.8055 },
  { name: "Arles", lat: 43.6766, lng: 4.6278 },
  { name: "Nîmes", lat: 43.8367, lng: 4.3601 },
  { name: "Perpignan", lat: 42.6887, lng: 2.8948 },
  { name: "Narbonne", lat: 43.1843, lng: 3.0031 },
  { name: "Béziers", lat: 43.3442, lng: 3.2158 },
  { name: "Sète", lat: 43.4028, lng: 3.6986 },

  // =====================
  // OUEST / BRETAGNE
  // =====================
  { name: "Brest", lat: 48.3904, lng: -4.4861 },
  { name: "Quimper", lat: 47.9961, lng: -4.1029 },
  { name: "Vannes", lat: 47.6582, lng: -2.7608 },
  { name: "Lorient", lat: 47.7480, lng: -3.3661 },
  { name: "Saint-Brieuc", lat: 48.5146, lng: -2.7650 },

  // =====================
  // EST / ALPES / JURA
  // =====================
  { name: "Gap", lat: 44.5582, lng: 6.0785 },
  { name: "Briançon", lat: 44.8994, lng: 6.6429 },
  { name: "Albertville", lat: 45.6746, lng: 6.3900 },
  { name: "Thonon-les-Bains", lat: 46.3700, lng: 6.4796 },

  // =====================
  // NORD / GRAND EST
  // =====================
  { name: "Amiens", lat: 49.8941, lng: 2.2957 },
  { name: "Arras", lat: 50.2910, lng: 2.7772 },
  { name: "Metz", lat: 49.1193, lng: 6.1757 },
  { name: "Nancy", lat: 48.6921, lng: 6.1844 },
  { name: "Épinal", lat: 48.1749, lng: 6.4516 },

  // =====================
  // CENTRE / RURAL
  // =====================
  { name: "Moulins", lat: 46.5646, lng: 3.3326 },
  { name: "Aurillac", lat: 44.9263, lng: 2.4449 },
  { name: "Rodez", lat: 44.3510, lng: 2.5734 },
  { name: "Millau", lat: 44.1006, lng: 3.0780 },
];
